module.exports = __webpack_public_path__ + "static/media/gb-wls.85f8b842.svg";